import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { Auction } from "../types";
import {
	getAuctionsAsync,
	getAuctionDetailsAsync,
	GetAuctionsAsyncPayload,
	GetAuctionDetailsPayload,
	setAuctions,
	CreateAuctionPayload,
	createNewAuctionAsync,
	setAuction,
	updateAuctionAsync,
	UpdateAuctionPayload,
	GetBidsPayload,
	getBidsAsync,
	setBids,
} from "./auction.slice";

// Get list
function* getAuctionsSaga(action: PayloadAction<GetAuctionsAsyncPayload>) {
	const { query, callback } = action.payload;
	let { skip } = query;
	const { take } = query;
	skip = skip * take;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Auction[]>>(
				"/dashboard/auction-sections",
				{ ...query, skip },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setAuctions.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetAuctions() {
	yield takeLatest(getAuctionsAsync, getAuctionsSaga);
}

// Get auction details
function* getAuctionDetailsSaga(
	action: PayloadAction<GetAuctionDetailsPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Auction>>(
				`/dashboard/auction-sections/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setAuction.type, payload: response.data });
		!!callback && callback()
	} else {
		message.error(translate(error.message));
	}
}

function* watchAuctionDetails() {
	yield takeLatest(getAuctionDetailsAsync, getAuctionDetailsSaga);
}

// Create new auction
function* createNewAuctionSaga(action: PayloadAction<CreateAuctionPayload>) {
	const { data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("/dashboard/auction-sections", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback(true);
	} else {
		message.error(translate(error.message));
		callback(false);
	}
}

function* watchCreateAuction() {
	yield takeLatest(createNewAuctionAsync, createNewAuctionSaga);
}


// Update auction
function* updateAuctionSaga(action: PayloadAction<UpdateAuctionPayload>) {
	const { data, id, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard/auction-sections/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateAuction() {
	yield takeLatest(updateAuctionAsync, updateAuctionSaga);
}

// Get bids
function* getBidsSaga(action: PayloadAction<GetBidsPayload>) {
	const { id, query } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Auction>>(
				`/dashboard/auction-sections/${id}/biddings`, query
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setBids.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetBids() {
	yield takeLatest(getBidsAsync, getBidsSaga);
}

const auctionSaga = [
	watchGetAuctions(),
	watchAuctionDetails(),
	watchCreateAuction(),
	watchUpdateAuction(),
	watchGetBids(),
];
export default auctionSaga;
